var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.545776 0H1.20923L1.56335 0.354126L1.56417 0.353312L11.9831 10.7722L10.9931 11.7622L7.63668 8.40573V11.4545C7.63668 11.6761 7.50032 11.8722 7.3043 11.9574C7.23612 11.983 7.15941 12 7.09123 12C6.94634 12 6.80998 11.9489 6.70771 11.8381L4.52589 9.65625C4.42362 9.55398 4.36396 9.41761 4.36396 9.27273V5.133L0.574219 1.34326L0.575378 1.3421L0.162253 0.928977C0.000321042 0.775568 -0.0422926 0.536932 0.0429347 0.332386C0.128162 0.136363 0.324185 0 0.545776 0ZM11.8384 0.928977L7.97825 4.78912L3.18913 0H11.4549C11.6765 0 11.8725 0.136363 11.9577 0.332386C12.0429 0.536932 12.0003 0.775568 11.8384 0.928977Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilter);
export default __webpack_public_path__ + "static/media/close-filter.a75e4340f7455016c1692cc0635fb62d.svg";
export { ForwardRef as ReactComponent };